import { useState } from "react";
import { Award, Download, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { learn } from "@/lib/learnApi";

const Stat = ({ label, done, total, testId }) => (
  <div data-testid={testId} className="rounded-xl bg-white/10 px-4 py-2.5">
    <p className="text-[12px] uppercase tracking-[0.14em] text-slate-300">{label}</p>
    <p className="font-display text-[20px] font-bold text-white">{done}<span className="text-slate-400">/{total}</span></p>
  </div>
);

export const CertificateCard = ({ course, cert }) => {
  const [busy, setBusy] = useState(false);
  if (!cert) return null;
  const ok = cert.eligible;
  const download = async () => {
    setBusy(true);
    try { await learn.certificate(course); toast.success("Certificate downloaded"); }
    catch { toast.error("Could not download your certificate. Please try again."); }
    finally { setBusy(false); }
  };
  return (
    <section data-testid="certificate-card" className={`grain relative overflow-hidden rounded-2xl p-6 md:p-8 ${ok ? "bg-[#0E9384]" : "bg-[#0B1B33]"}`}>
      <div className="pointer-events-none absolute -bottom-20 -right-10 h-56 w-56 rounded-full border-[26px] border-white/10" />
      <div className="relative flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-4">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-white/15">{ok ? <Award className="h-6 w-6 text-white" /> : <Lock className="h-5 w-5 text-teal-300" />}</span>
          <div>
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal-100">Completion certificate</p>
            <h3 data-testid="certificate-status" className="font-display mt-1 text-[22px] font-bold leading-tight text-white">{ok ? "You've earned your certificate" : "Finish everything to unlock it"}</h3>
            <p className="mt-1 text-[14px] text-slate-200">{ok ? "Signed by Rakesh, Founder, ArtOfResume." : "Tick every session checklist item and submit every project."}</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <Stat testId="certificate-checklist-count" label="Checklist" done={cert.checklist_done} total={cert.checklist_total} />
          <Stat testId="certificate-projects-count" label="Projects" done={cert.projects_done} total={cert.projects_total} />
          {ok && (
            <button data-testid="certificate-download-btn" onClick={download} disabled={busy} className="flex items-center gap-2 rounded-full bg-white px-5 py-3 text-[15px] font-semibold text-[#0B1B33] transition-transform hover:-translate-y-0.5 disabled:opacity-70">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Download PDF
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
